var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"title":_vm.$t('dashboard.tickets_this_month')}},[_c('div',{staticClass:"p-4"},[_c('canvas',{ref:"chart"})])])}
var staticRenderFns = []

export { render, staticRenderFns }